// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"j8","navPanel":"j8","nav-panel-bg":"j9","navPanelBg":"j9","nav-panel-content":"j-","navPanelContent":"j-","none":"j_","block":"ka"};